import { useEffect, useState } from 'react';
import Icon from '../../components/forms/icon.component';

type ThemeMode = 'light' | 'dark' | 'system';

function DropTheme() {
  const [mode, setMode] = useState<ThemeMode>('system');

  const themes = [
    {
      value: 'light',
      label: 'Claro',
      icon: 'ki-night-day'
    },
    {
      value: 'dark',
      label: 'Oscuro',
      icon: 'ki-moon'
    },
    {
      value: 'system',
      label: 'Sistema',
      icon: 'ki-screen'
    }
  ];

  const applyTheme = (theme: ThemeMode) => {
    setMode(theme);
    localStorage.setItem('theme-mode', theme);

    const html = document.documentElement;

    if (theme === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      html.setAttribute('data-bs-theme', prefersDark ? 'dark' : 'light');
    } else {
      html.setAttribute('data-bs-theme', theme);
    }

    window.dispatchEvent(new Event('themeChanged'));
  };

  useEffect(() => {
    const saved = (localStorage.getItem('theme-mode') as ThemeMode) || 'system';
    applyTheme(saved);

    const media = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = () => {
      if (saved === 'system') {
        applyTheme('system');
      }
    };

    media.addEventListener('change', handleChange);

    return () => media.removeEventListener('change', handleChange);
  }, []);

  const currentTheme = themes.find((t) => t.value === mode) || themes[2];

  return (
    <div
      className="menu-item px-5 z-index-5"
      data-kt-menu-trigger="{default:'click', lg:'hover'}"
      data-kt-menu-placement="left-start"
    >
      <span className="menu-link px-0 b-radius d-flex align-items-center">
        <span className="menu-icon">
          <Icon icon="ki-screen" size="fs-2" />
        </span>

        <span className="menu-title">Apariencia</span>

        <span className="ms-auto d-flex align-items-center gap-2 px-3 py-2">
          <Icon icon={currentTheme.icon} size="fs-2" type="primary" className="fw-bolder" />
        </span>
      </span>

      <div className="menu-sub menu-sub-dropdown w-200px py-4 z-index-5">
        {themes.map((theme) => (
          <div key={theme.value} className="menu-item px-3 z-index-5">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                applyTheme(theme.value as ThemeMode);
              }}
              className={`menu-link b-radius d-flex align-items-center px-5 ${
                mode === theme.value ? 'active' : ''
              }`}
            >
              <span className="menu-icon me-4">
                <Icon icon={theme.icon} size="fs-2" />
              </span>

              {theme.label}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DropTheme;
